import { Controller, useFormContext } from 'react-hook-form';

import { styled } from '@mui/material/styles';
import TextareaAutosize from '@mui/material/TextareaAutosize';
 
// ----------------------------------------------------------------------
 
const StyledTextarea = styled(TextareaAutosize)(({ theme }) => ({
  width: '100%',
  padding: '8px 12px',
  borderRadius: theme.shape.borderRadius,
  border: `1px solid ${theme.palette.divider}`,
  backgroundColor: 'transparent',
  fontFamily: theme.typography.fontFamily,
  fontSize: theme.typography.body1.fontSize,
  '&:focus': {
    outline: 'none',
    borderColor: theme.palette.primary.main,
  },
  '&:hover': {
    borderColor: theme.palette.text.primary,
  },
  '&::placeholder': {
    color: theme.palette.text.disabled,
  },
}));
 
// ----------------------------------------------------------------------
 
export function RHFTextArea({ name, helperText, minRows = 3, ...other }) {
  const { control } = useFormContext();
 
  return (
<Controller
      name={name}
      control={control}
      render={({ field, fieldState: { error } }) => (
<div>
<StyledTextarea
            {...field}
            minRows={minRows}
            placeholder={other.placeholder}
            style={{
              borderColor: error ? '#FF4842' : '',
            }}
            {...other}
          />
          {(error?.message || helperText) && (
<span
              style={{
                display: 'block',
                marginTop: '4px',
                fontSize: '0.75rem',
                color: error ? '#FF4842' : 'inherit',
                whiteSpace: "pre-line"
              }}
>
              {error?.message || helperText}
</span>
          )}
</div>
      )}
    />
  );
}